import(/* webpackMode: "eager" */ "/app/app/boticario/relatorio1/page.tsx");
